import { render, staticRenderFns } from "./ClientItem.vue?vue&type=template&id=a8285aa4&scoped=true&"
import script from "./ClientItem.vue?vue&type=script&lang=js&"
export * from "./ClientItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8285aa4",
  null
  
)

export default component.exports